<script setup>
import { computed } from 'vue';

const props = defineProps({
  status: {
    type: String,
    required: false,
    default: 'MATCH', // we default to green if no status passed
    validator: (value) => ['MATCH', 'NOT_APPLICABLE', 'TECHNICAL_PROBLEMS', 'PRESENT', 'MISMATCH', 'MISSING'].includes(value)
  },
  icon: {
    type: String,
    required: true
  },
  tooltipText: {
    type: String,
    required: true,
  },
});

const statusClasses = computed(() => {
  const classMap = {
    'MISSING': {
      container: 'tw-bg-danger-100 tw-border-danger',
      icon: 'tw-text-danger-600'
    },
    'PRESENT': {
      container: 'tw-bg-caution-100 tw-border-caution-600',
      icon: 'tw-text-caution-700'
    },
    'MISMATCH': {
      container: 'tw-bg-caution-100 tw-border-caution-600',
      icon: 'tw-text-caution-700'
    }
  };

  const successClasses = {
    container: 'tw-bg-success-100 tw-border-success-600',
    icon: 'tw-text-success-700'
  };

  return classMap[props.status] || successClasses;
});

const formattedTootlipText = computed(() => {
  if (props.status === 'MISSING') {
    return `${props.tooltipText} Not Found`;
  }

  if (props.status === 'PRESENT' || props.status === 'MISMATCH') {
    return `${props.tooltipText} Inaccurate`;
  }

  return `${props.tooltipText} Correct`;
});
</script>

<template>
  <div
    v-tooltip="{
      placement: 'bottom',
      theme: 'dark-blue-tooltip',
      content: formattedTootlipText,
    }"
    :class="[
      'tw-w-6 tw-h-6 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-border tw-cursor-pointer',
      statusClasses.container
    ]"
  >
    <svg-vue
      :class="[
        'tw-w-4 tw-h-4 tw-shrink-0',
        statusClasses.icon
      ]"
      :icon="`icons/${icon}`"
    />
  </div>
</template>
